import { render } from "./nextButton.vue?vue&type=template&id=2c0ead63"
import script from "./nextButton.vue?vue&type=script&lang=js"
export * from "./nextButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__